import './SiteLogo.scss';
import { Link } from 'react-router-dom';

export const logoUrl =
  'https://rizosrealty.blob.core.windows.net/site-content/logo.png';

export const SiteLogoLink = () => (
  <div className='site-logo'>
    <Link to='/'>
      <img src={logoUrl} alt='Logo' />
    </Link>
  </div>
);
